import { render } from "./ButterFly.vue?vue&type=template&id=5c966e30&scoped=true"
import script from "./ButterFly.vue?vue&type=script&lang=js"
export * from "./ButterFly.vue?vue&type=script&lang=js"

import "./ButterFly.vue?vue&type=style&index=0&id=5c966e30&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.16_vue@3.5.16_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c966e30"]])

export default __exports__